<template>
  <div id="book-preview">
    <template v-if="pageData">
      <div v-for="item in images">
        <el-row><img :src="item.virtualRoute + item.resourceImg" @click="enlargePic"/></el-row>
        <el-row> <span class="page-num">第 {{item.sortIndex+1}} 页</span></el-row>
      </div>
      <template v-if="isDialogShow">
      </template>
      <el-dialog custom-class="dialog-custom" :visible.sync="centerDialogVisible" modal close-on-click-modal>
        <div style="height:680px">
          <el-carousel :autoplay="false" arrow="always">
            <div style="height: 660px">
              <el-carousel-item style="height: 650px" v-for="item in images" :key="item.id">
                <img :src="item.virtualRoute + item.resourceImg">
              </el-carousel-item>
            </div>
          </el-carousel>
        </div>
      </el-dialog>
    </template>
  </div>
</template>

<script>
export default {
  name: "showImgList",
  props: ["pageData","showPageNum"],
  data(){
    return{
      centerDialogVisible: false,
      showPic: '',
      isDialogShow: false,
      index: 0,
    }
  },
  computed: {
    images() {
      if (this.pageData instanceof Array && this.pageData.length > 2) {
        return this.pageData.splice(0,this.showPageNum)
      } else {
        return this.pageData
      }
    }
  },
  methods: {
    // 放大图片
    enlargePic(e){
      this.isDialogShow = true;
      this.centerDialogVisible = true;
      this.showPic = this.pageData[0];
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#book-preview{
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding:15px 0;
  img{
    width: 100px;
    height: 140px;
    padding:5px;
    border: #e2e2e2 solid 1px;
    box-shadow: 3px 3px 6px 0px rgba(0,0,0,0.1);
  }
  .dialog-custom {
    min-height: 560px  !important;
    height: 640px  !important;
    img{
      width: 100%;
      height: 100%;
      margin: 0;
    }
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
    height: 100%;
    width: 100%;
  }
  .el-dialog__header{
    display: none;
  }
  .el-dialog__body {
    padding: 0 !important;
    margin: 0 !important;
  }
  .el-carousel{
    height: 100%;
  }
  .el-carousel__container {
    height: 620px;
    height: 100%;
  }
  .page-num{
    margin: 4px;
    width: 90px;
    display:inline-block;
    align-items: center;
    text-align:center;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/readpage/showimglist.vue